/**
 * Standalone-viewer stub for the debug-mode module.
 *
 * The real module wires `store`, `impersonateUser` (→ api/session) and
 * localforage storage into a global `window.bmsDebug` console helper. The
 * viewer doesn't need any of that, and importing it would drag the api layer
 * back into the bundle. We keep only the surface `logChangedProps.js` relies
 * on: a `getDebugMode()` that returns an inert, logging-disabled object.
 */
export const debugModeNamespace = 'bmsDebug';

const inertDebugMode = {
  loggerIsEnabled: false,
  getLoggerValue: (propName, defaultValue) => defaultValue,
  getState: () => ({}),
};

export const getDebugMode = () => inertDebugMode;

export default () => inertDebugMode;
